<template>
  <el-container class="height100">
    <el-main class="el-mainContent paddingLeft0">
    <!-- <el-divider content-position="left" class="el-divider-header">操作</el-divider> -->
    <div class="obpm-fromContent-title obpm-enterpriseDomain-logo clearfix normalHeight">
      <el-col :span="12" class="normalLineH">{{$t('emailconfig')}}</el-col>
      <el-col :span="12" class="obpm-oneBtn normalLineH" style="text-align:right">
        <el-button type="primary" @click="onSaveBtnClick" size="small">{{$t('save')}}</el-button>
      </el-col >
    </div>
    <el-form ref="form" :model="content" label-position="top" label-width="180px" size="mini">
      <!-- <el-divider content-position="left">系统邮件发送设置</el-divider> -->
      <p class="smallHeader">{{$t('mail_setting')}}</p>
      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('sendHost')" class="padding0Label">
            <el-input v-model="content.sendHost"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('sendAddress')" class="padding0Label">
            <el-input v-model="content.sendAddress"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('sendAccount')" class="padding0Label">
            <el-input v-model="content.sendAccount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('sendPassword')" class="padding0Label">
            <el-input v-model="content.sendPassword" show-password></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('ccAddress')" class="padding0Label">
            <el-input v-model="content.ccAddress"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <p class="smallHeader">{{$t('base_setting')}}</p>
      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('isUseClient')" class="padding0Label">
            <el-switch v-model="content.isUseClient"  active-value="true" inactive-value="false" @change="changeUseClient"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5"  :offset="6">
          <el-form-item :label="$t('functionDomain')" class="padding0Label">
            <el-input v-model="content.functionDomain" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <p class="smallHeaderNoBorder">{{$t('file_mapping')}}</p>
      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('trash')" class="padding0Label">
            <el-input v-model="content.trash" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('sender')" class="padding0Label">
            <el-input v-model="content.sender" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('draft')" class="padding0Label">
            <el-input v-model="content.draft" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('removed')" class="padding0Label">
            <el-input v-model="content.removed" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <p class="smallHeader">{{$t('fetchssl')}}</p>
      <p class="smallHeaderNoBorder">{{$t('fetchServer_config')}}</p>
      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('fetchServer')" class="padding0Label">
            <el-input v-model="content.fetchServer" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('fetchServerPort')" class="padding0Label">
            <el-input v-model="content.fetchServerPort" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('fetchProtocol')">
            <el-input v-model="content.fetchProtocol" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('fetchssl')">
            <el-switch v-model="content.fetchssl"  active-value="true" inactive-value="false" :disabled="!isUse"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <p class="smallHeaderNoBorder">{{$t('send_serve_config')}}</p>
      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('smtpServer')">
            <el-input v-model="content.smtpServer" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('smtpServerPort')">
            <el-input v-model="content.smtpServerPort" :disabled="!isUse"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="5">
          <el-form-item :label="$t('smtpAuthenticated')">
            <el-switch v-model="content.smtpAuthenticated" :disabled="!isUse" active-value="true" inactive-value="false"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="5" :offset="6">
          <el-form-item :label="$t('smtpssl')">
            <el-switch v-model="content.smtpssl" :disabled="!isUse" active-value="true" inactive-value="false"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    </el-main>
  </el-container>
</template>
<script>
export default {
  created() {
    this.$api.getEmailConfig(this.$route.query.domainid, {
      onSucess: resp => {
        this.content = resp.data.data;
        if(this.content.isUseClient=="true"){
          this.isUse=true;
        }
      }
    });
  },
  data() {
    return {
      content: {},
      isUse:false,
    };
  },

  methods: {
    changeUseClient(val){
      if(val=="false"){
        this.isUse=false;
      }else{
        this.isUse=true;

      }
    },
    onSaveBtnClick(){
      let domainid = this.$route.query.domainid;
      this.$api.updateEmailConfig(domainid, this.content, {
        onSucess: resp => {
          if (resp && resp.data.errcode == 0) {
            this.$message({
              showClose: true,
              message: this.$t('msg_save_success'),
              type: "success"
            });
            this.$api.getEmailConfig(this.$route.query.domainid, {
              onSucess: resp => {
                this.content = resp.data.data;
              }
            });
          } else {
            this.$message({
              showClose: true,
              message: resp.data.errmsg,
              type: "error"
            });
          }
        }
      });
    }
  }
};
</script>

<style>
</style>